import { isNPageOrHigherPageView, isValidContentType, isValidSection, isIOS9, } from '@frontend/web/components/SignInGate/displayRule';
import { hasUserDismissedGate } from '../dismissGate';
const canShow = (CAPI, isSignedIn, currentTest) => !isSignedIn &&
    !hasUserDismissedGate(currentTest.variant, currentTest.name) &&
    isNPageOrHigherPageView(3) &&
    isValidContentType(CAPI) &&
    isValidSection(CAPI) &&
    !isIOS9();
export const signInGateComponent = {
    canShow,
};
